import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import {SortingState, IntegratedSorting, PagingState, IntegratedPaging, SearchState, IntegratedFiltering} from '@devexpress/dx-react-grid';
import {Grid,Table,TableHeaderRow,SearchPanel,Toolbar,TableColumnReordering,DragDropProvider,TableColumnVisibility,ColumnChooser} from '@devexpress/dx-react-grid-bootstrap4';
import {PagingPanel} from '@devexpress/dx-react-grid-material-ui';
import '../../theme/styles/dx-react-grid-bootstrap4.css';
import '../../theme/styles/reactstrap.css';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
var styles=require('./Report.less');
import {DropdownButton, MenuItem, Button} from 'react-bootstrap';
import * as commonActions from './../../actions/commonActions';
import * as reportActions from './../../actions/reportActions';
import moment from 'moment-timezone';
import * as tradepanelActions from './../../actions/tradepanelActions';
import '../../theme/styles/mediaqueries.css';
import Modal from 'react-modal';
import * as filesaver from './../../actions/FileSaver';
import config from './../../config.js';
import {DcoDropdown} from './../../components/UI/Dropdown/Dropdown';
import i18next from 'i18next';
import ReactExport from "react-data-export";
const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
import { applyStyle,applyToHover } from './../../utils/utils';
import DateSelector from './../DateSelector/DateSelector';
import {getSelectedDate,getCountofTableRows,setDirection} from './../../utils/utils'; //import
import { withStyles } from '@material-ui/core/styles';

const elementsData = [
  {"classNames":"activityfilterBar", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
  {"classNames":"activitytbl", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
  {"classNames":"fltrBarInner", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"reportsDropdown", "elementType":"normal", "applyTo":"all", "tagNames":"button"},
  {"classNames":"dropdown-toggle", "elementType":"normal", "applyTo":"all", "tagNames":"button"},
  {"classNames":"caret","elementType":"normal", "applyTo":"all", "tagNames":"span"},
  {"classNames":"dropdown-menu","elementType":"normal", "applyTo":"all", "tagNames":"ul"},
  {"classNames":"dropDownList","elementType":"tag", "applyTo":"all", "tagNames":"a"},
  {"classNames":"reportTblBg", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"glyphicon","elementType":"normal", "applyTo":"all", "tagNames":"span"},
  {"classNames":"material-icons","elementType":"normal", "applyTo":"all", "tagNames":"i"},
  {"classNames":"reportsTblGrid","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"form-control","elementType":"normal", "applyTo":"all", "tagNames":"input"},
  {"classNames":"oi-eye","elementType":"normal", "applyTo":"all", "tagNames":"span"},
  {"classNames":"mdlWrap","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"dx-g-bs4-table","elementType":"normal", "applyTo":"all", "tagNames":"table"},
  {"classNames":"dx-g-bs4-header-cell","elementType":"tag", "applyTo":"all", "tagNames":"div"},
  {"classNames":"dx-g-bs4-table-cell","elementType":"tag", "applyTo":"all", "tagNames":"td"},
  {"classNames":"text-muted","elementType":"tag", "applyTo":"all", "tagNames":"big","parent":"dx-g-bs4-fixed-block"},
  {"classNames":"calenderOptions", "elementType":"normal", "applyTo":"all", "tagNames":"button"},
  {"classNames":"noDataCell","elementType":"tag", "applyTo":"all", "tagNames":"td"},
  {"classNames":"closeBtn","elementType":"normal", "applyTo":"single", "tagNames":"div"},
];
const clickVals = [];
const directionData=[
  {"classNames":"commonGoBtn", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
  {"classNames":"actvityDrpdownDiv", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"selectDatebtn", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"card-header", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
  {"classNames":"btnText","elementType":"normal", "applyTo":"all", "tagNames":"button"},
  {"classNames":"dropdown-menu","elementType":"normal", "applyTo":"all", "tagNames":"ul"},
  {"classNames":"reportsTblGrid","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"allExportFilter","elementType":"normal", "applyTo":"all", "tagNames":"div"},
];

@connect(state => ({
  activityData: state.dashboardRoot.reportReducer.activityData,
  selectedCssColorTheme:state.dashboardRoot.commonReducer.selectedCssColorTheme,
  selectedCssColor:state.dashboardRoot.commonReducer.selectedCssColor,
  openCalender: state.dashboardRoot.commonReducer.openCalender,
  selectedLang:state.dashboardRoot.commonReducer.selectedLang,
  language:state.dashboardRoot.commonReducer.language
}), {
  ...reportActions,
  ...commonActions
})



export default class ReportComponent extends Component {
  static propTypes = {
    activityData: PropTypes.object,
    loadActivityReport: PropTypes.func.isRequired,
    generateActivityPdf:PropTypes.func,
    onClickCalender:PropTypes.func,
    //getInvoice: PropTypes.func,
    openCalender:PropTypes.boolean,
  }
  constructor(props) {

    super(props);
    this.state = {
      activitySession_opt: "currentSession",
      id:'today',
      sessionType: '1',
      currentDate: new Date().toLocaleDateString('en-US'),
      startDate: new Date().toLocaleDateString('en-US'),
      endDate: new Date().toLocaleDateString('en-US'),
      orderBy:'D',
      showRptDialog: false,
      loadtableflag :true,
      isRefreshDisabled:  true,
      isClearActivityLog:false,
      ranges: {
        // [i18next.t('Today')]: [
        //   moment(), moment()
        // ],
        [i18next.t('yesterday')]: [
          moment().subtract(1, 'days'),
          moment().subtract(1, 'days')
        ],
        [i18next.t('last7Days')]: [
          moment().subtract(6, 'days'),
          moment()
        ],
        [i18next.t('last30Days')]: [
          moment().subtract(29, 'days'),
          moment()
        ],
        [i18next.t('thisMonth')]: [
          moment().startOf('month'), moment().endOf('month')
        ],
        [i18next.t('lastMonth')]: [
          moment().subtract(1, 'month').startOf('month'),
          moment().subtract(1, 'month').endOf('month')
        ]
      },
      pageSizes: [10, 15, 20, 0],
      searchValue:'',
      HiddenactivityDataCol:[],
      validationFlag:false,
      keyValue:'activityLogReport',
      reportsRowsCount:0,
      activityColumnOrder:["det","docNo","remark"]
    }
    this.onChangeSearchValue = this.onChangeSearchValue.bind(this);
    this.onChangeHiddenactivityDataCol = this.onChangeHiddenactivityDataCol.bind(this);
    this.afterOpenModal = this.afterOpenModal.bind(this);
  }
  componentDidMount() {
    const thisComponent = ReactDOM.findDOMNode(this);
    // //const allCssStyleRules = this.props.selectedCssColorTheme;
    // applyStyle(thisComponent, allCssStyleRules, elementsData);
    setDirection(ReactDOM.findDOMNode(this),directionData,this.props.selectedLang);
    const hoverElementsClassNames = [
        {"elmToHover":thisComponent.getElementsByClassName("closeBtn")[0], "classNames":"closeBtn"},
        {"elmToHover":thisComponent.getElementsByClassName("button-l")[0], "classNames":"button-l"},
    ];
    ////applyToHover(thisComponent, hoverElementsClassNames, allCssStyleRules);
  }
  componentWillMount() {
    const locale = locale;
    this.setState({
        locale: {
            'format': 'DD-MM-YYYY',
            applyLabel: i18next.t('apply'),
            cancelLabel: i18next.t('cancel'),
            customRangeLabel:  i18next.t('customRange'),
            daysOfWeek: [
              i18next.t("su"),i18next.t("mo"),i18next.t("tu"),i18next.t("we"),i18next.t("th"),i18next.t("fr"),i18next.t("sa")
            ],
            monthNames:[
              i18next.t("jan"),i18next.t("feb"),i18next.t("mar"),i18next.t("apr"),i18next.t("may"),i18next.t("jun"),i18next.t("jul"),  i18next.t("aug"),i18next.t("sep"),i18next.t("oct"),i18next.t("nov"),i18next.t("dec")
            ]
        },
        });
 }

 componentWillReceiveProps(nextProps){
  // if(this.props.selectedCssColorTheme !== nextProps.selectedCssColorTheme){
  //   const thisComponent = ReactDOM.findDOMNode(this);
  //   const allCssStyleRules = nextProps.selectedCssColorTheme;
  //   applyStyle(thisComponent, allCssStyleRules, elementsData);
  //   const hoverElementsClassNames = [
  //       {"elmToHover":thisComponent.getElementsByClassName("closeBtn")[0], "classNames":"closeBtn"},
  //       {"elmToHover":thisComponent.getElementsByClassName("button-l")[0], "classNames":"button-l"},
  //   ];
  //   //applyToHover(thisComponent, hoverElementsClassNames, allCssStyleRules);
  // }
  if (this.props.selectedLang !== nextProps.selectedLang) {
    const thisComponent = ReactDOM.findDOMNode(this);
    setDirection(ReactDOM.findDOMNode(this),directionData,nextProps.selectedLang);
  }
  if(this.state.isClearActivityLog !== this.props.isClearActivityLog){
    this.setState({ isClearActivityLog: true });
    this.setState({ loadtableflag: true });
    this.setState({isRefreshDisabled:true});
    this.setState({startDate: new Date().toLocaleDateString('en-US')});
    this.setState({endDate:new Date().toLocaleDateString('en-US')});
    this.setState({currentDate: new Date().toLocaleDateString('en-US')});
    this.setState({id:'today'});
  }
  if(nextProps.activityData !== this.props.activityData){
    this.setState({ loadtableflag: false });
    this.setState({ isRefreshDisabled : false });
    this.setState({ reportsRowsCount : nextProps.activityData.length });
  }
 }
  handleActivitySubmit = () => {
    try{
      this.setState({ loadtableflag: true });
      this.setState({isRefreshDisabled:true});
      if (this.state.sessionType === '1') {
        this.props.loadActivityReport('1','', '', 'D');
      }else {
        this.props.loadActivityReport(this.state.sessionType,moment(this.state.startDate).format('DD-MM-YYYY'), moment(this.state.endDate).format('DD-MM-YYYY'), 'D');
      }
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'handleActivitySubmit', component:"ActivityLogRegister"});
    }
  }
  // selectDateRange = (event, picker) => {
  //   this.setState({startDate: picker.startDate.format('DD-MM-YYYY'), endDate: picker.endDate.format('DD-MM-YYYY')});
  // }
  activitySession_opt = (event, sessionType) => {
    try{
      this.setState({activitySession_opt: event});
      this.setState({sessionType: sessionType});
      this.setState({ loadtableflag: true });
      if(sessionType === '3'){
            this.props.loadActivityReport(sessionType,moment(this.state.startDate).format('DD-MM-YYYY'), moment(this.state.endDate).format('DD-MM-YYYY'), 'D');
      }else{
        this.props.loadActivityReport(sessionType,'', '', 'D');
      }
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'activitySession_opt', component:"ActivityLogRegister"});
    }
  }

  generatePdf=(format)=>{
    try{
      if(this.props.activityData == ''){
      this.setState({showRptDialog:true});
      }else{
      this.setState({showRptDialog:false});
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    this.props.generateActivityPdf(this.state.sessionType, moment(this.state.startDate).format('DD-MM-YYYY'), moment(this.state.endDate).format('DD-MM-YYYY'), 'D',format,timezone);
    }
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'generatePdf', component:"ActivityLogRegister"});
    }
  }

  closeRptModal = (event) => {
    try{
    this.setState({showRptDialog: false});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'closeRptModal', component:"ActivityLogRegister"});
    }
  }

  setStartDate = startDate => {
    try{
      this.setState({ startDate:startDate});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'setStartDate', component:"ActivityLogRegister"});
    }
  }

  setEndDate = endDate => {
    try{
      this.setState({ endDate:endDate });
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'setEndDate', component:"ActivityLogRegister"});
    }
  }

  closeValidationModal = () => {
    try {
      this.setState({ validationFlag: false });
    } catch (e) {
      this.props.logFileCreation({ error: e.message, originFunction: 'closeValidationModal', component: "ActivityLogRegister" });
    }
  }

 //  generateInvoice=(row)=>{
 //    var docNo=row.toString().split('""');
 //    var getdocType = row.toString().split('/');
 //    var docType=getdocType[0];
 //    //this.props.getInvoice(docNo,docType);
 //    // var DocNo=row.docNo;
 //    // var docNo=DocNo.split('""');
 //    // var getdocType = DocNo.split('/');
 //    // var docType=getdocType[0];
 //    if(docType ==='FNC'){
 //      this.props.getInvoice(docNo,docType);
 //     }
 // }

  onChangeSearchValue(value){
    try{
      this.setState({searchValue: value });
      var count=getCountofTableRows(this.props.activityData,this.state.activityColumnOrder,value);
      this.setState({reportsRowsCount: count });
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onChangeSearchValue', component:"ActivityLogRegister"});
    }
  }
  onChangeHiddenactivityDataCol(hiddenCol){
    try{
      this.setState({ HiddenactivityDataCol : hiddenCol});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onChangeHiddenactivityDataCol', component:"ActivityLogRegister"});
    }
  };
  changeFlag = () => {
    try{
      this.setState({showRptDialog: true});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'changeFlag', component:"ActivityLogRegister"});
    }
  }
  afterOpenModal() {
    try{
      const thisComponent = this.refs.errorMSG;
      //  //const allCssStyleRules = this.props.selectedCssColorTheme;
      //  const elementsData = [
      //    {"classNames":"closeBtn","elementType":"normal", "applyTo":"single", "tagNames":"div"},
      //    {"classNames":"button-l","elementType":"normal", "applyTo":"single", "tagNames":"button"},
      //  ];
      //  applyStyle(thisComponent, allCssStyleRules, elementsData);
      const directionData = [
        {"classNames":"header", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
        {"classNames":"commonCloseIcon", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
        {"classNames":"commonMsgDir", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
        {"classNames":"button-l","elementType":"normal", "applyTo":"single", "tagNames":"button"},
      ];
      setDirection(thisComponent,directionData,this.props.selectedLang);
      const hoverElementsClassNames = [
        {"elmToHover":thisComponent.getElementsByClassName("closeBtn")[0], "classNames":"closeBtn"},
        {"elmToHover":thisComponent.getElementsByClassName("button-l")[0], "classNames":"button-l"},
      ];
      ////applyToHover(thisComponent, hoverElementsClassNames, allCssStyleRules);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'afterOpenModal', component:"ActivityLogRegister"});
    }
  }
  render() {
    let label = this.state.startDate + ' - ' + this.state.endDate;
    if (this.state.startDate === this.state.endDate) {
      label = this.state.startDate;
    }
    const activitytablecols = [
      {name:'det',title:i18next.t('activityTime'), width: {wpx: 200}},
      {name:'docNo',title:i18next.t('docNo'), width: {wpx: 150}},
      {name:'remark',title:i18next.t('activity'), width: {wpx: 400}}
    ];
    var tableData = [];
    var propData = this.props.activityData;

    for(let i=0;i<propData.length;i++){
       tableData[i] = [{value: propData[i].det, style: {alignment: {horizontal:"left"}}},{value: propData[i].docNo, style: {alignment: {wrapText: true,horizontal:"left"}}}, {value: propData[i].remark, style: {alignment: {horizontal:"left"}}}];
     }

    let multiDataSet = [
      {
        columns: activitytablecols,
        data: tableData
      }
    ];
    const pagingPanelMessages = {
      showAll: (i18next.t('all')),
      rowsPerPage: (i18next.t('rowsPerPage')),
      info:'',
    };
    const searchPlaceholderMsg = {
      searchPlaceholder: (i18next.t('search'))+'...',
    };
    const PagingContainer = props => (
      <PagingPanel.Container {...props} className="pagingPanelDiv" />
    );
    const PagingContainerdark = props => (
      <PagingPanel.Container {...props} className="pagingPanelDivDark"  />
    );


    // const GenerateInvoiceCell = ({value}) => (
    //   <Table.Cell>
    //     <span>
    //       {value.indexOf('FNC') !== -1 ? <a className='actLogRptCell' title={i18next.t("Click here to download invoice")} onClick={()=>this.generateInvoice(value)}>
    //         {value}
    //       </a>
    //     :value}
    //     </span>
    //   </Table.Cell>
    // );
    const Cell = props => {
      const { column } = props;
      if(column.name === "det"){
          return <Table.Cell {...props} className="eventTimeCell"/>;
      }
      return <Table.Cell {...props} />;
    };
    const rowStyle = theme => ({
      tableStriped: {
        '& tbody tr:nth-of-type(odd)': {
          // backgroundColor: this.props.selectedCssColorTheme.listRow.background,
          // color:this.props.selectedCssColorTheme.listRow.color
        },
        '& tbody tr:nth-of-type(even)': {
          // backgroundColor: this.props.selectedCssColorTheme.rptListRowNext.background,
          // color:this.props.selectedCssColorTheme.listRow.color
        },
        '& thead th': {
          ////color:this.props.selectedCssColorTheme.tableHeaderColor.color
        },
        '& .text-primary': {
          ////color: this.props.selectedCssColorTheme.activeHeaderColor.color
        }
      },
    });
    const dropDownListColor =theme =>({
          dropDownListHoverMenu:{
            '& .dropdown-item':{
                // background:this.props.selectedCssColorTheme.dropDownList.background,
                // color:this.props.selectedCssColorTheme.dropDownList.color
              },
              '& :hover':{
                // background:this.props.selectedCssColorTheme.dropDownListHover.background,
                // color:this.props.selectedCssColorTheme.dropDownListHover.color
              }
          }
        });

    const ContainerColor = ({ classes, ...restProps }) => (
          <ColumnChooser.Container {...restProps} className={classes.dropDownListHoverMenu}  />
        );
       const MenuColor = props => (
           <ColumnChooser.Item {...props} />
     );

    const TableComponentBase = ({ classes, ...restProps }) => (
      <Table.Table {...restProps} id="activityLogRpt" className={classes.tableStriped}/>
    );
    var NoDataMsg = {
      noData: '',
    }
    if (this.state.loadtableflag === true) {
      NoDataMsg.noData = '';
    }
    else {
      NoDataMsg.noData = i18next.t('noDataAvlMsg');
    }
    const NoDataCell = props => (
      <Table.NoDataCell {...props} className="noDataCell"/>
    );

    return (
      <div id="activityLogRptMain" className={`${this.props.language}`}>
      <Modal isOpen={this.state.validationFlag} id="actLogDateValModal" className={styles.warningModal} onAfterOpen={this.afterOpenModal}>
        <div ref="errorMSG" className="mdlWrap" style={this.props.selectedCssColorTheme.mdlWrap}>
          <div className={`${styles.header} header`} style={this.props.selectedCssColorTheme.rptModalHeader}>{i18next.t("error")}
            <span onClick={this.closeValidationModal} className={`${styles.closeImg} closeIcon`}>{this.props.closeIcon}</span>
          </div>
          <div className={`${styles.msg} commonMsgDir`} >
            <h4>{i18next.t("dateSelectorErrMsg")}</h4>
          </div>
        </div>
      </Modal>
      <Modal isOpen={this.state.showRptDialog} className={styles.warningModal} id="activityLogModal" onAfterOpen={this.afterOpenModal}>
        <div ref="errorMSG" className="mdlWrap" >
          <div className={`${styles.header} header`} >
            <span className={`${styles.msgTitle}`}>{i18next.t('activityLogReg')}</span>
            <span onClick={this.closeRptModal} className={`${styles.closeImg} closeIcon`} id="closeLogModalIcon">{this.props.closeIcon}</span>
          </div>
          <div className={`${styles.msg} commonMsgDir`} style={this.props.selectedCssColorTheme.rptModalMsg}>
            {i18next.t("noDataAvlMsg")}
          </div>
          <div className={`${styles.btnWrap} col-md-12`}>
              <Button className='button-l' bsStyle="primary" onClick={this.closeRptModal} id="closeLogBtn" >{i18next.t("OK")}</Button>
          </div>
        </div>
      </Modal>
        <div className={`${styles.activityfilterBar} activityfilterBar  ${this.props.selectedCssColor}`} id="actLogDiv">
          <div className={`${styles.activityfilterBarInner} fltrBarInner`}>
            <iframe id="my_iframe" className={styles.displayNone}></iframe>
            <div className={`${styles.activityfilterItem} actvityDrpdownDiv`} id="activityopt">
              <DropdownButton title={i18next.t(this.state.activitySession_opt)} id="bg-nested-dropdown" className="reportsDropdown btnText">
                <MenuItem eventKey='1' onClick={() =>this.activitySession_opt("currentSession","1")} id="currSessionMenu">{i18next.t("currentSession")}</MenuItem>
                <MenuItem eventKey='2' onClick={() =>this.activitySession_opt("today","2")} id="todaySessionMenu">{i18next.t("today")}</MenuItem>
                <MenuItem eventKey='3' onClick={() =>this.activitySession_opt("archives","3")} id="archivesMenu">{i18next.t("archives")}</MenuItem>
              </DropdownButton>
            </div>
            {this.state.sessionType === '3'
              ? <div className={`${styles.selectDatebtn} actvityDrpdownDiv`} id="rptActDateBtn" style={this.props.selectedLang.selectDatebtn}>
                  <DateSelector
                     keyValue={this.state.keyValue}
                     onClickFilter={this.handleActivitySubmit}
                     setStartDate={this.setStartDate}
                     setEndDate={this.setEndDate}
                     component='Report'
                   />
                </div>
              : null}


            <div className={`${styles.exportfileBaracc} allExportFilter`}>
              <div className="commonGoBtn" id="activitygobtn">
                <button type="button" className={this.state.isRefreshDisabled === true ? `${styles.disabled} ${styles.goBtn}` : `${styles.goBtn}` } id="logRefreshBtn"
                onClick={() => this.handleActivitySubmit()}>
                  {this.props.refreshIcon}
                </button>
              </div>
              <label className={this.state.loadtableflag === true ? "disableLabel" : null}>
                {(this.props.activityData.length!==0) && <span>
                <ExcelFile  filename="ActivityLogRegister" element={(<img src="/images/xls.png"/>)}>
                    <ExcelSheet dataSet={multiDataSet} name="ActivityLogRegister" />
                </ExcelFile>
                </span>}
                {(this.props.activityData.length===0) && <img src="/images/xls.png" onClick={this.changeFlag}/>}
                <span><img src="/images/pdf.png" onClick={()=>{this.generatePdf("PDF")}} id="logGenPDF" /></span>
              </label>
            </div>
          </div>
        </div>
        <div className={`${styles.activitytbl} activitytbl`} id="activitytbl">
        {this.state.loadtableflag === true ?
          <div className={`${styles.rptoverlay} rptLoader`} >
              <i className="fa fa-spinner fa-spin spin-big"></i>
          </div>
        : null}
        <div className="reportsTblGrid" id="activityGrid">
          <Grid rows={this.props.activityData} columns={activitytablecols}>
            <SortingState defaultSorting={[{ columnName: 'det', direction: 'desc' }]}/>
            <IntegratedSorting />
            {this.state.reportsRowsCount>10 && this.props.selectedCssColor !== "DR" ?<PagingState defaultCurrentPage={0} defaultPageSize={10}/>
            :this.state.reportsRowsCount>10 && this.props.selectedCssColor === "DR" ?<PagingState defaultCurrentPage={0} defaultPageSize={10}/>:null}

            <SearchState value={this.state.searchValue} onValueChange={this.onChangeSearchValue}/>
            <IntegratedFiltering />
            {this.state.reportsRowsCount>10?<IntegratedPaging />
            :null}
            <Table tableComponent={withStyles(rowStyle, { name: 'TableComponent' })(TableComponentBase)}
            	messages={NoDataMsg} noDataCellComponent={NoDataCell} cellComponent={Cell}/>
            <TableHeaderRow showSortingControls />
            <TableColumnVisibility hiddenColumnNames={this.state.HiddenactivityDataCol} onHiddenColumnNamesChange={this.onChangeHiddenactivityDataCol}/>
            {this.state.reportsRowsCount>10 && this.props.selectedCssColor !== "DR" ?<PagingPanel pageSizes={this.state.pageSizes} messages={pagingPanelMessages} containerComponent={PagingContainer}/>
            :
            this.state.reportsRowsCount>10 && this.props.selectedCssColor === "DR" ?
            <PagingPanel pageSizes={this.state.pageSizes} messages={pagingPanelMessages} containerComponent={PagingContainerdark}/>
            :null}
            <Toolbar />
            <SearchPanel messages={searchPlaceholderMsg} autoComplete="new-password"/>
          <ColumnChooser  containerComponent={withStyles(dropDownListColor, { name: 'ContainerComponent' })(ContainerColor)} itemComponent={MenuColor} />
          </Grid>
        </div>
        </div>
      </div>
    );
  }
}
